const totalByCase = (invoices) => {

    let total = 0;

    if(invoices && invoices.length) {

        invoices.forEach(i => {
            if(i.status === 'sent') {
                total = total + parseFloat(i.total)
            }
        })

    }

    return total.toFixed(2)

}

export default totalByCase;